import React from "react";
import { BeatLoader } from "react-spinners";
import styled from "styled-components";

const StyledLoading = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;
const defaultProps = { color: "#f26341" };
const Loading = (props) => {
  const { color = defaultProps.color } = props;
  return (
    <StyledLoading>
      <BeatLoader color={color} />
    </StyledLoading>
  );
};

export default Loading;
